import { L as LicenseCollection, I as InstallerCollection, g as getUsersByEmail } from "../../../../chunks/firebase.js";
const load = async ({ locals, depends }) => {
  if (locals.user) {
    const licenseSnapshot = await LicenseCollection().doc(locals.user.email).get();
    const installerSnapshot = await InstallerCollection().doc(locals.user.email).get();
    const deviceQuery = await getUsersByEmail(locals.user.email);
    if (licenseSnapshot.exists) {
      const license = licenseSnapshot.data();
      const licenseIssuedOn = licenseSnapshot.createTime?.toDate();
      const devices = deviceQuery.docs.map((doc) => doc.data()?.id);
      let installer = installerSnapshot.data();
      if (installer?.cancelled) {
        installer = void 0;
      }
      return {
        license: {
          ...license,
          issuedOn: licenseIssuedOn
        },
        installer,
        devices
      };
    }
  }
  return {};
};
export {
  load
};
